import React, { useEffect, useState } from 'react'
import {
  TextField,
  FormControlLabel,
  Switch,
  Button,
  Card,
  Typography,
  Grid,
} from '@material-ui/core'
import { CustomModal } from '../../../../components/common/CustomModal'
import { PasswordInputWithRules } from './PasswordInputWithRules'
//@ts-ignore
import { createUser } from '../../../../api/complianceService'
//@ts-ignore
import { openErrorMessage } from '../../../../actions/message'
import { CreateBiotrackUserProps } from './biotrackUserTypes'

export const CreateBiotrackUser = ({
  open,
  onClose,
  employee,
  assignedShop,
  dispatch,
  roles,
}: CreateBiotrackUserProps) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isAdmin, setIsAdmin] = useState(false)
  const [enableAll, setEnableAll] = useState(true)
  const [useBlazePermissions, setUseBlazePermissions] = useState(false)
  const [passwordValidity, setPasswordValidity] = useState({
    length: false,
    number: false,
    uppercase: false,
    lowercase: false,
    symbol: false,
  })

  useEffect(() => {
    if (open && employee) {
      setUsername(employee.email)
    }
  }, [open, employee])

  const handleToggle = (toggle: 'enableAll' | 'useBlaze', checked: boolean) => {
    if (toggle === 'enableAll') {
      setEnableAll(checked)
      if (checked) setUseBlazePermissions(false)
    } else {
      setUseBlazePermissions(checked)
      if (checked) setEnableAll(false)
    }
  }

  const handleSubmit = async () => {
    if (!password || !username) {
      return dispatch(openErrorMessage('User name and password are required.'))
    }

    if (password !== confirmPassword) {
      return dispatch(openErrorMessage('Passwords do not match.'))
    }

    const allRulesValid = Object.values(passwordValidity).every(Boolean)
    if (!allRulesValid) {
      return dispatch(openErrorMessage('Password must include all required elements.'))
    }

    const permissions = useBlazePermissions
      ? roles?.find((role) => role.id === employee?.roleId)?.permissions
      : []

    const payload = {
      data: {
        attributes: {
          username,
          password,
          internalId: employee?.id,
          admin: isAdmin,
          permissions: permissions,
        },
      },
    }

    try {
      await createUser(assignedShop?.companyId, assignedShop?.id, payload)
      dispatch(openErrorMessage('User created successfully!'))
      onClose()
    } catch (err: any) {
      const detail = err?.response?.data?.errors?.[0]?.detail ?? err?.message ?? 'Failed'
      dispatch(openErrorMessage(detail))
    }
  }

  return (
    <CustomModal open={open} onClose={onClose} size="medium">
      <CustomModal.Header
        title={'Create Biotrack User'}
        onClose={onClose}
        variant="caption"
        titleSx={{
          textAlign: 'center',
        }}
      />
      <CustomModal.Content>
        <TextField
          fullWidth
          label="User name"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          margin="normal"
        />
        <PasswordInputWithRules
          password={password}
          onChange={setPassword}
          passwordValidity={passwordValidity}
          setPasswordValidity={setPasswordValidity}
        />
        <TextField
          fullWidth
          label="Confirm Password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          margin="normal"
        />

        <FormControlLabel
          control={<Switch checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} />}
          label="Create as Admin in BioTrack"
        />

        <Card style={{ padding: 16, marginTop: 16 }}>
          <Typography>BT Permissions</Typography>
          <Grid container>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={enableAll}
                    onChange={(e) => handleToggle('enableAll', e.target.checked)}
                    disabled={useBlazePermissions}
                  />
                }
                label="Enable All"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={useBlazePermissions}
                    onChange={(e) => handleToggle('useBlaze', e.target.checked)}
                    disabled={enableAll}
                  />
                }
                label="Use Blaze Role Permissions"
              />
            </Grid>
          </Grid>
        </Card>
      </CustomModal.Content>
      <CustomModal.Footer alignment="center">
        <Button className="primary-button" onClick={handleSubmit}>
          Create
        </Button>
      </CustomModal.Footer>
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/BiotrackUser/CreateBiotrackUser.tsx